import { render, staticRenderFns } from "./roomAvailability.vue?vue&type=template&id=2f40a5cb&scoped=true"
import script from "./roomAvailability.vue?vue&type=script&lang=js"
export * from "./roomAvailability.vue?vue&type=script&lang=js"
import style0 from "./roomAvailability.vue?vue&type=style&index=0&id=2f40a5cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f40a5cb",
  null
  
)

export default component.exports